(function() {
  angular.module('cfn').factory('Field', Field);

  Field.$inject = ['dataSource.factory'];

  function Field(dataSource) {
    return dataSource('field').getRestService();
  }
})();
